import { faMagnifyingGlass, faPaperclip, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Tab, Tabs, Modal, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments.js';
import ImageUpload from '../../../Components/common/ImageUpload.js';
import trash from "../../../assets/images/trash.png";
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import edit from "../../../assets/images/edit.png";
import Export from "../../../assets/images/export.svg";
import Cargoplane from "../../../assets/images/plane.svg";
import Header from "../../../Components/Header/Header.js";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../Components/TopMenu/TopMenu.js';
import { withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts.js';
import Rapdf from "../../../assets/images/pdf.png"
import pen from "../../../assets/images/pen.png";
import Plantripimg from "../../../assets/images/plan_trip.png";
import LinkImage from '../../../assets/images/link.png';

import { toast } from 'react-toastify';
import { applyOffsetToDateTime, CallApi, CommonModal, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import ConfModal from '../../../Components/common/ConfModal.js';
const ActiveTrips = ({ PtClick, DClick, PDClick, stockClick }) => {

  const tabName = localStorage.getItem('grid_tab');
  const [activeTab, setActiveTab] = useState(tabName || 'Active');
  const [detailsId, setDetailsId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [disLoading, setDisLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [deleteId, setDeleteId] = useState('');
  const [selectedData, setSelectedData] = useState();
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: [],
    // Trash: []

  });
  const isMounted = useRef(false);

  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [filterApplied, setFilterApplied] = useState(false);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [gridSelect, setGridSelect] = useState([]);
  const [editData, setEditData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    localStorage.setItem('grid_tab', tab);
    //const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }

  };

  let checkUlds = [];
  let filterForCheck = false;


  useEffect(() => {
    if (isMounted.current) return;

    setIsLoading(false);
    setGridData({ Active: {} });
    localStorage.removeItem("source_page");

    isMounted.current = true;
  }, []);
  useEffect(() => {
    console.log('selectedData', selectedData);
  }, [selectedData]);

  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.ULD;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
      const endpoint = tabType === 'A'
        ? 'uld-control/active-trip-list'
        : 'uld-control/archive-trip-list';
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'contro_receipt_no', type: 'string' },
          { name: 'receipt', type: 'string' },
          { name: 'trip_status', type: 'string' },
          { name: 'return_station', type: 'string' },
          { name: 'organization', type: 'string' },
          { name: 'transfer_date', type: 'string' },
          { name: 'time_slot', type: 'string' },
          { name: 'door', type: 'string' },
          { name: 'warehouse_out', type: 'string' },
          { name: 'handler_in', type: 'string' },
          { name: 'acceptance', type: 'date' },
          { name: 'handler_out', type: 'string' },
          { name: 'warehouse_in', type: 'string' },
          { name: 'uld_count', type: 'string' },
          { name: 'driver_name', type: 'string' },
          { name: 'trucking_company', type: 'string' },
          { name: 'uld_informations', type: 'array' },
          { name: 'handler_org_id', type: 'array' },
          { name: 'handler_station', type: 'array' },

        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/uld-receipt-list?tab_name=${tabType}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRef.current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRef.current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      let columns = [
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '5%', filterable: false,
        },
        { text: 'Control Receipt No.', filtertype: 'input', datafield: 'contro_receipt_no', width: '7%', cellclassname: '', },
        {
          text: 'ULD', filtertype: 'input', datafield: 'uld_count', width: '3%', cellclassname: '',
          // cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
          //   // console.log('value.uld_informations', value);

          //   if (value.length) {
          //     return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.length + '</div>';
          //   } else {
          //     return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">0</div>';
          //   }
          // },
        },
        {
          text: 'Receipt', filterable: false, width: '4%', cellclassname: '', dataField: 'receipt',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            // console.log('aa', cellValue);
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        {
          text: 'Trip Status', filtertype: 'textbox', datafield: 'trip_status', width: '8%', filtertype: 'checkedlist',
          filteritems: [
            { label: 'Planned', value: 'Planned' },
            { label: 'Active', value: 'Active' },
            { label: 'Completed', value: 'Completed' },
          ],
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            // Check the value of the 'Status' field
            if (rowdata.trip_status === 'Completed') {
              // Return HTML with class 'inactive' for 'i' status
              return '<div class="jqx-grid-cell-left-align fw_complet">Completed</div>';
            } else if (rowdata.trip_status === 'Planned') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align fw_planed">Planned</div>';
            } else if (rowdata.trip_status === 'Active') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align fw_progess">Active</div>';
            } else {
              // Return default HTML
              return defaulthtml;
            }
          }
        },

        {
          text: 'Return Station', filtertype: 'input', datafield: 'handler_station', width: '6%', cellclassname: '',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
            // console.log('value.uld_informations', value);

            if (value.code) {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.code + '</div>';
            } else {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"></div>';
            }
          },
        },
        {
          text: 'Handler Name', filtertype: 'input', datafield: 'organization', width: '8%', cellclassname: '',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
            if (value.org_Name == null) {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"> </div>';
            } else {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.org_Name + '</div>';
            }
          },
        },
        { text: 'Driver', filtertype: 'input', datafield: 'driver_name', width: '8%', cellclassname: '', },
        { text: 'Trucking Company', filtertype: 'input', datafield: 'trucking_company', width: '8%', cellclassname: '', },
        { text: 'Transfer Date', filtertype: 'range', datafield: 'transfer_date', width: '8%', cellclassname: '', },
        { text: 'Timeslot', filtertype: 'textbox', datafield: 'time_slot', width: '6%', cellclassname: '', },
        {
          text: 'Door', filtertype: 'textbox', datafield: 'door', width: '6%', cellclassname: '',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
            console.log('value.uld_informations', value);

            if (value.door_no) {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.door_no + '</div>';
            } else {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"> </div>';
            }
          },
        },

        {
          text: 'Handler In', datafield: 'handler_in', width: '10%',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen"><img src="' + pen + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        {
          text: 'Handler Out', datafield: 'handler_out', width: '10%', cellclassname: "",
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen"><img src="' + pen + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },

        {
          text: 'Warehouse In', datafield: 'warehouse_in', width: '12%',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen"><img src="' + pen + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        {
          text: 'Warehouse Out', datafield: 'warehouse_out', width: '12%',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen"><img src="' + pen + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        { text: 'Acceptance', filtertype: 'textbox', datafield: 'acceptance', width: '8%', cellclassname: '', },
      ];

       window.$(gridRefs[activeTab].current).on("celldoubleclick", function (event) {
            const args = event.args;
            const datafield = args.datafield;
            if (['contro_receipt_no'].includes(datafield)) {
                  const cellValue = args.value;
                 if (cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '') {
                    navigator.clipboard.writeText(String(cellValue))
                      .then(() => {
                        toast.success("Copied to clipboard: " + cellValue);
                      })
                      .catch(err => {
                        // optional error handling
                        // console.error("Failed to copy:", err);
                      });
                  }
              }
        });

      if (activeTab === 'Archived') {
        columns = columns.filter(col => col.datafield !== 'trip_status');
      }
      const nestedColumns = [

        // { text: 'ULD Number', datafield: 'uld_number', width: '10%' },
        {
          text: 'ULD Number',
          width: '10%',
          filtertype: 'textbox',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
            let uldNumber = rowData.uld_number || '';
            let imageHtml = uldNumber ? `<img src="${LinkImage}" alt="Link" style="width: 15px;margin-right: 7px;" />` : '';
            return `<div class="receipt-number-cell jqx-grid-cell-left-align" data-receipt="${uldNumber}" style="margin-top:13px;">
                            ${imageHtml} ${uldNumber}
                        </div>`;
          }
        },
        { text: 'Type Code', datafield: 'type_code', width: '8%' },
        { text: 'Serial No.', datafield: 'serial_number', width: '8%' },
        { text: 'Owner Code', datafield: 'owner_code', width: '8%' },
        {
          text: 'Airline Name', datafield: 'airline_master', width: '15%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
            // console.log('value.uld_informations', value);

            if (value) {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.airline_name + '</div>';
            } else {
              return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"></div>';
            }
          }
        },
        {
          text: 'Condition Code', datafield: 'condition_code', width: '8%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            if (rowdata.condition_code === 'SER') {
              return '<div class="jqx-grid-cell-left-align set_dock ">Servicable</div>';
            } else if (rowdata.condition_code === 'DAM') {
              return '<div class="jqx-grid-cell-left-align set_dock">Damaged</div>';
            } else {
              return '<div class="jqx-grid-cell-left-align set_dock">Discarded</div>';
            }
          },
        },

      ];

      const nestedGrids = {};
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const nestedGridContainer = parentElement.children[0];
        // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);
        // console.log('nestedGridContainer', nestedGridContainer);

        const parentRowId = record.uid.toString();
        nestedGrids[parentRowId] = nestedGridContainer;

        parentElement.addEventListener('click', (event) => {
          const target = event.target;
          // Check if the click target is the nested arrow
          if (window.$(target).hasClass('jqx-icon-arrow-right')) {
            // Handle nested arrow click here
            // console.log('Nested arrow clicked:', record);
            event.stopPropagation(); // Prevent event bubbling to the row details
          }
        });
        // console.log(dataAdapter);
        const id = record.uid.toString();
        console.log('uldGrid', dataAdapter.loadedData.Rows[id]);
        const rId = dataAdapter.loadedData.Rows[id]
        const uldGrid = dataAdapter.loadedData.Rows[id].uld_informations;
        // console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
        // const hawbGrid = [dataAdapter.loadedData.Rows[id].id];
        // const subendPoint = `uld-control/nested-trip-list?id=${hawbGrid}`;
        const nestedSource = {
          datatype: 'json',
          id: 'shipmentChildID',
          datafields: [
            { name: 'id', type: 'string' },
            { name: 'uld_number', type: 'string' },
            { name: 'type_code', type: 'string' },
            { name: 'serial_number', type: 'string' },
            { name: 'owner_code', type: 'string' },
            { name: 'airline_master', type: 'string' },
            { name: 'condition_code', type: 'string' },

          ],
          // localdata: uldGrid,
          url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/uld-receipt-sub-grid?receipt_id=${rId.id}`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader('Authorization', token);
          // },
          root: "Rows",
          // // localdata: gridData[activeTab],
          // pagesize: 50,
          // filter: function (allfilters) {
          //   if (allfilters.length > 0) {
          //     setFilterApplied(true);
          //     filterForCheck = true;
          //   } else {
          //     setFilterApplied(false);
          //     filterForCheck = false;
          //   }
          //   window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          //   window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          //   // setTimeout(() => {
          //   //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

          //   //     console.log("rows", rows);
          //   //     (checkUlds).forEach(uldNumber => {
          //   //         console.log(checkUlds);
          //   //         rows.forEach((element, index) => {
          //   //             if (element.uld_number == uldNumber) {
          //   //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
          //   //             }
          //   //         });
          //   //     });
          //   // }, 4000);
          // },
          // beforeprocessing: function (data) {
          //   source.totalrecords = data.TotalRows;
          //   setTotalRows({ totalUlds: data.activeCount });
          //   setTotalRowsR({ totalUlds: data.archiveCount });
          //   setSelectedData(data)
          // },
          // sort: function () {
          //   window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
          // },

          // cache: false,
        }
        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
        const nestedGridOptions = {
          width: '100%',
          pageable: false,
          sortable: false,
          // pageSize: 15,
          autoheight: false,
          height: (10 * 45),
          selectionmode: 'none', // checkbox
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: true,
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            // Manually set row IDs starting from 0
            const rows = window.$(nestedGridContainer).jqxGrid('getrows');
            for (let i = 0; i < rows.length; i++) {
              const rowid = i; // Use index as the new row ID
              const row = rows[i];
              window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
              window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
              window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
            }
          },
        };
        window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
        window.$(nestedGridContainer).on('click', '.receipt-number-cell', function () {
          // const receiptNumber = window.$(this).data('receipt');
          // const filter = [{
          //   datafield: "control_receipt_numb",
          //   filters: [{
          //     condition: "CONTAINS",
          //     operator: 1,
          //     value: receiptNumber
          //   }]
          // }];
          // localStorage.setItem("usFilter", JSON.stringify(filter));
          // stockClick()

          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr('row-id');
          const rowData = window.$(nestedGridContainer).jqxGrid('getrowdata', rowIndex);
          // console.log('rowDiv', rowData);
          const localData = { id: rowData.id, source: 'uldStock' }
          localStorage.setItem('Fdetails', JSON.stringify(localData));
          DClick()
        });
      };
      // Nested End
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        initrowdetails: initrowdetails,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails: '<div id="nestedGrids" style="margin: 10px;"></div>',
          rowdetailsheight: (10 * 45),
          // rowdetailshidden: true,
        },
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          localStorgeFilter();
        },
        // rendered: function () {
        //   const rows = window.$(gridRef.current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRef.current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        localStorage.removeItem('plan_trip');
        localStorage.removeItem('EditFULD');
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        // const dataToSend = {
        //   uld_number: rowData.uld_number,
        //   type_code: rowData.type_code,
        //   serial_number: rowData.serial_number,
        //   owner_code: rowData.owner_code,
        //   condition_code: rowData.condition_code,
        //   // asset_type: rowData.asset_type == 'Y' ? false : true

        // };
        loadDetails(rowData.id, 'E');
        // loadDetails('E', rowData.awbId);
        // localStorage.setItem('plan_trip', JSON.stringify(lData));
        // localStorage.setItem('grid_tab', activeTab);
        // localStorage.setItem('back_plan', JSON.stringify('/ULDForwarder/ActiveTrips'));
        // window.location.href = '/ULDForwarder/PlanTrip'

        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRefs[activeTab].current).on('click', '.row_delete', function () {

        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

        setDeleteId(rowData.id);
        setConfData({
          header: `Selected ${gridSelect.length > 1 ? "Row's" : 'Row'} will be deleted`,
          subHeader: `Are you sure you want to delete?`,
          modalConf: confirmDelete,
          // closeModal: {confModalClose},
          primaryBtn: 'Close Case',
          secondaryBtn: 'Cancel',
        })
        setModalConf(true);
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.id;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.id === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.id === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });
      let clickTimer = null;
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).off('celldoubleclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        clearTimeout(clickTimer);

        clickTimer = setTimeout(() => {
          const args = event.args.row.bounddata;
          console.log("event", event)
          // if (activeTab === 'Active') {
          if (event.args.columnindex > 2 && !([5, 14, 15, 16, 17].includes(event.args.columnindex))) {
            if (gridSelect) {
              gridSelect.forEach(item => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
              });
            }
            loadDetails(args.id, 'D');
            // setSelectedRowData(args)
            setDetailsId(args.id);

          } else if ([14, 15, 16, 17].includes(event.args.columnindex)) {
            const rowIndex = event.args.rowindex;
            const columnField = event.args.datafield;
            const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            handleSetFunction(columnField, rowData.id, rowData[columnField])
            setDetailsId(args.id);
          } else { }
        }, 200);
      });
      window.$(gridRefs[activeTab].current).on('celldoubleclick', (event) => {
        clearTimeout(clickTimer);
        const args = event.args.row.bounddata;
        const cellValue = event.args.value;
        if (cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '') {
          navigator.clipboard.writeText(String(cellValue))
            .then(() => {
              toast.success("Copied to clipboard: " + cellValue);
            })
            .catch(err => {
              // optional error handling
              // console.error("Failed to copy:", err);
            });
        }
      });
      // }
    }
  }, [gridData]);

  function localStorgeFilter() {
    let savedFilters = localStorage.getItem('ptFilter');
    if (savedFilters) {
      savedFilters = JSON.parse(localStorage.getItem('ptFilter'));
      savedFilters.forEach(element => {
        const filterValue = element.filters[0].value;
        if (filterValue !== null && filterValue !== undefined) {
          const filterGroup = new window.$.jqx.filter();
          const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
          const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
          filterGroup.addfilter(1, filter);
          window.$(gridRefs[activeTab].current).jqxGrid("addfilter", 'contro_receipt_no', filterGroup);
        }
      });
      window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
      localStorage.removeItem('ptFilter');
    }
  };
  const loadDetails = async (uldNumber, pos) => {
    setDisLoading(true);
    CallApi({
      endPoint: 'forwarder-uld-control/receipt-details',
      payload: { receipt_id: uldNumber },
      onSuccess: (data) => {
        const resCode = data.data.response_code;
        if (resCode === 200) {
          const innerData = data.data.response_data;
          if (pos === 'E') {
            const filteredGridSelect = innerData?.uld_informations?.map(
              ({ uld_number, type_code, owner_code, serial_number, condition_code, id, assigned, handlerOrgId }) => ({
                uld_number,
                type_code,
                owner_code,
                serial_number,
                condition_code,
                uld_id: id,
                assigned,
                handlerOrgId
              })
            );
            const lData = {
              station_name: innerData?.handler_station?.code,
              handler_id: innerData.handler_org_id,
              control_receipt_numb: innerData.control_receipt_numb,
              door: innerData.door,
              planned_slot: innerData.planned_slot,
              planned_transfer_date: innerData.planned_transfer_date,
              trip_id: innerData.id,
              acn_id: innerData.acin_id,
              trucking_company: innerData.drivername,
              driver_name: innerData?.drivername,
              vehicle_id: innerData?.vehicle?.truck_Registration_Number,
              warehouse_id: innerData?.warehouse_id,
              trailer_id: innerData?.trailer_nr,
              remarks: innerData?.remarks,
              slot: innerData?.slots.length ? innerData?.slots[0] : null,
              files: innerData?.attachments,
              booking_slot_datetime: `${innerData?.planned_transfer_date}T${innerData?.planned_time}`,
              ulds: filteredGridSelect
            };
            localStorage.setItem('plan_trip', JSON.stringify(lData));
            PtClick()
          } else if (pos === 'D') {
            setSelectedRowData(innerData);
            setDisLoading(false);
            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }
  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };

  const confModalClose = () => {
    setModalConf(false);
  }

  const [actArcModal, setActArcModal] = useState(false);
  const [modalMode, setModalMode] = useState({ id: '', pos: '' });
  const handleMoveToActArc = () => {
    if (gridSelect.length <= 0) {
      toast.error('Please select grid data before send');
    } else {
      setConfData({
        header: `Selected ${gridSelect.length > 1 ? "Row's" : 'Row'} will move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`,
        subHeader: `Are you sure you want to move ${gridSelect.length > 1 ? "Row's" : 'Row'} to ${activeTab == 'Active' ? 'Archive' : 'Active'}?`,
        modalConf: confirmMoveToActArc,
        // closeModal: {confModalClose},
        primaryBtn: 'Close Case',
        secondaryBtn: 'Cancel',
      })
      setModalConf(true);
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = () => {
    // console.log('101', gridSelect);
    const sendAction = activeTab == 'Active' ? 'archived' : 'active';
    const uldNumbers = gridSelect && gridSelect.map(num => num.id)
    CallApi({
      endPoint: 'forwarder-uld-action/update-receipt-activity-status',
      payload: { receipt_ids: uldNumbers, status: sendAction },
      onSuccess: (data) => {
        const innerData = data.data;
        if (innerData.response_code === 200) {
          gridSelect.forEach(item => {
            const selectedRowBoundIndex = item.boundindex;
            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
          });
          toast.success(data.data.response_msg);
          window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        }
        setModalConf(false)
      },
      onError: (msg) => toast.error(msg)
    });
  }

  const confirmDelete = () => {
    CallApi({
      endPoint: 'forwarder-action/delete-plan-trip',
      payload: { ids: [deleteId] },
      onSuccess: (data) => {
        const innerData = data.data;
        if (innerData.response_code === 200) {
          toast.success(data.data.response_msg);
          window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        }
        setModalConf(false)
      },
      onError: (msg) => toast.error(msg)
    });
    // try {
    //   const res = await withRFSToken.post('forwarder-action/delete-plan-trip', { ids: [deleteId] })
    //     .then(function (res) {
    //       const innerData = res.data.response_data;
    //       setTimeout(() => {
    //         setIsLoading(false);
    //         window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
    //       }, 1);
    //       setActArcModal(false)
    //     });
    // } catch (error) {
    //   console.error('Error fetching data:', error);
    // }
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
  };


  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);


  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  // Modal Start
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ updateFlag: '', set_date: getCurrentDateTime() });

  const handleSetFunction = (pos, id, date) => {
    setIsModal(true);
    const position = pos === 'handler_in' ? 'HI' : (pos === 'handler_out' ? 'HO' : (pos === 'warehouse_in' ? 'WI' : (pos === 'warehouse_out' ? 'WO' : '')))
    setModalData({ updateFlag: position, id: id, set_date: date || getCurrentDateTime() })
  }
  const isModalClose = () => {
    setIsModal(false);
    setModalData({ updateFlag: '', id: '', set_date: getCurrentDateTime() })
  }

  const modalInputChange = (name, value) => {
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

  const updateDate = async () => {
    // console.log('payload', modalData);
    try {
      const res = await withRFSToken.post('forwarder-action/set-trip-field', modalData)
        .then(function (res) {
          const innerData = res.data.response_data;
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            isModalClose();
            setTimeout(() => {
              setIsLoading(false);
              window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
            }, 1);
          } else {
            toast.error(res.data.response_msg);
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handlePlanTrip = () => {
    localStorage.removeItem('plan_trip')
    localStorage.removeItem('EditFULD')
    if (gridSelect.length > 0) {
      const isSameHandler = gridSelect.every(
        (item) => item.company_name === gridSelect[0].company_name
      );
      // const isSameStation = gridSelect.every(
      //   (item) => item.company_name === gridSelect[0].return_station
      // );
      if (isSameHandler) {
        const filteredGridSelect = gridSelect.map(({ uld_number, type_code, owner_code, serial_number, condition_code }) => ({
          uld_number,
          type_code,
          owner_code,
          serial_number,
          condition_code
        }));
        const ids = gridSelect.map(data => data.id)
        localStorage.setItem('plan_trip', JSON.stringify({ uld_id: ids }));
        localStorage.setItem('back_plan', 'AT');
        window.location.href = '/ULDForwarder/PlanTrip';
      } else {
        toast.error('All selected ULDs must have the same Origin Company and Station !');
      }
    } else {
      localStorage.setItem('back_plan', 'AT');
      window.location.href = '/ULDForwarder/PlanTrip';
    }
  }

  const handleDetails = () => {
    const localData = { id: detailsId, source: 'activeTrips' }
    localStorage.setItem('Fdetails', JSON.stringify(localData));
    // localStorage.setItem('source_page', 'activeTrips');
    // window.location.href = '/ULDForwarder/Details';
    PDClick()
  }

  return (
    <>
      {/* <div className="">
        <Header />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel rounded">
            <div className="mainTab">
              <TopMenu module='FORWARDER' />
              <div className="">
                <div className="allcontent-fl"> */}
      {/* <div className='d-flex justify-content-end mb-3 order_search'>
                  <div className='search'>
                    <div className="form-group has-search">
                      <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                      <input type="text" className="form-control" placeholder="Search" />
                    </div>
                  </div>
                </div> */}
      {/* <div className="lcontent"> */}
      {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={confData.modalConf}
          closeModal={confModalClose}
          primaryBtn={'Yes'}
          secondaryBtn={'No'}
        />
      }
      <div className="mb-0 nestedtabs rounded minh">
        <div className='d-flex justify-content-between'>
          {/* <div className='d-flex'>
                        <div>
                          <button className="plan_trip" variant="primary" onClick={handlePlanTrip}>
                            <span className='flex_center'> <img src={Plantripimg} /> Plan Trip</span>
                          </button>
                        </div>
                        <span className="selected">
                          Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                      </div> */}
          <div className='d-flex'>
            <div className='ulddown'>
              {activeTab === 'Active' && <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>}
              {/* {activeTab === 'Archived' && <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>} */}
              <button ><img src={Export} /> Download</button>

            </div>
          </div>
        </div>
      </div>
      <div className='maindiv'>
        <div className='trashdonload'>
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
              {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
            </Tab>
          </Tabs>
        </div>
        {selectedRowData && (
          <div className='SecondDiv mt-45'>
            {console.log('55', selectedRowData)}
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData.control_receipt_numb} &nbsp;
                <span
                  className={
                    selectedRowData.trip_status == 'Completed' ? 'fw_complet'
                      : selectedRowData.trip_status == 'Planned' ? 'fw_planed'
                        : selectedRowData.trip_status == 'Active' ? 'fw_progess'
                          : ''}>
                  {selectedRowData.trip_status}
                </span>
              </h3>
              <div className='d-flex actbtn justify-content-between'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                <div className='viwall'>
                  <Link to='#' onClick={handleDetails}>View Details</Link>
                </div>
              </div>
            </div>
            <div className='update_info'>
              <div className='d-flex justify-content-between align-items-center MB-2'>
                <h4>Trip Details</h4>
              </div>
              <ul>
                <li>
                  <span>Date In :</span>
                  {/* <span>{selectedRowData?.createDate?.slice(0, 10) + ' ' + selectedRowData?.createDate?.slice(11, 16)}</span> */}
                  <span>{applyOffsetToDateTime(selectedRowData?.createDate, 'H')}</span>
                </li>
                <li>
                  <span>Date Out :</span>
                  <span>{applyOffsetToDateTime(selectedRowData?.archiveDate, 'H')}</span>
                </li>
                <li>
                  <span>Receipt :</span>
                  <span><a href={selectedRowData?.receipt_pdf} target='_blank'><img src={Rapdf} alt="Link" style={{ width: '25px' }} /></a></span>
                </li>
              </ul>
            </div>
            {/* <div className='grid_details mt-2'>

              <h3 className="mb-0">Control Receipt Number: {selectedRowData.control_receipt_numb}</h3>

            </div> */}
            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"forwarder_plan_trip"}
              attachable_id={selectedRowData?.id}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.id, 'D')}
            />
            <ActivityComments
              commentable_type={"forwarder_plan_trip"}
              commentable_id={selectedRowData.id}
              allactivities={selectedRowData.activities}
              onReloadDetails={() => loadDetails(selectedRowData.id, 'D')}
            />
          </div>
        )}
      </div>
      {/* </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      <Modal show={isModal} onHide={isModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Set {modalData.updateFlag == 'HI' ? 'Handler In' : modalData.updateFlag == 'HO' ? 'Handler Out' : modalData.updateFlag == 'WI' ? 'Warehouse In' : 'Warehouse Out'}</h3>
          <div className='saairbill'>
            <Form.Label>Date<span>*</span></Form.Label>
            <Form.Control
              type="datetime-local" name='set_date'
              value={modalData.set_date || getCurrentDateTime()}
              onChange={(e) => modalInputChange('set_date', e.target.value)}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" disabled={isSaving} className='position-relative' onClick={isModalClose}>
                  Cancel
                </Button> */}
          <Button variant="primary" className='position-relative' onClick={updateDate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalMode.pos == 'D' ?
            <>
              <h3>Selected {gridSelect.length > 1 ? "Row's" : 'Row'} will be deleted</h3>
              <p>Are you sure you want to delete?</p>
            </>
            :
            <>
              <h3>Selected {gridSelect.length > 1 ? "Row's" : 'Row'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
              <p>Are you sure you want to move {gridSelect.length > 1 ? "Row's" : 'Row'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
            </>
          }

        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => setActArcModal(false)}>
              No
            </Button>
            <Button variant="primary" onClick={modalMode.pos == 'D' ? confirmDelete : confirmMoveToActArc}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* </div> */}
    </>
  )
}

export default ActiveTrips